// extracted by mini-css-extract-plugin
export var label = "_eu-5";
export var slideContainer = "_eu-0";
export var slider = "_eu-1";
export var sliderLg = "_eu-4";
export var sliderMd = "_eu-3";
export var sliderSm = "_eu-2";